import { Check, AlertCircle, Loader2, GitMerge } from "lucide-react";

const CONFIG = {
  saved: { icon: Check, label: "Saved", className: "text-ink-blue" },
  pending: { icon: Loader2, label: "Saving…", className: "text-ink-soft", spin: true },
  saving: { icon: Loader2, label: "Saving…", className: "text-ink-soft", spin: true },
  error: { icon: AlertCircle, label: "Couldn't save", className: "text-terracotta" },
  conflict: { icon: GitMerge, label: "Updated elsewhere", className: "text-mustard-dark" },
};

export default function AutosaveStatus({ status, onRetry, testId }) {
  const cfg = CONFIG[status] || CONFIG.saved;
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs shrink-0 ${cfg.className}`} data-testid={testId}>
      <Icon size={13} className={cfg.spin ? "animate-spin" : ""} />
      {cfg.label}
      {status === "error" && onRetry && (
        <button onClick={onRetry} className="underline hover:no-underline" data-testid={`${testId}-retry`}>
          Retry
        </button>
      )}
    </span>
  );
}
